import React, { useState } from 'react';
import { addUser } from '../../../utils/auth.controller';
import styles from './Login.module.css';
import CreateForm from '../../Design/Forms/CreateForm'; // Use CreateForm instead of Form
import { FormFields } from '../../Design/Forms/FormJson';  // Import your FormFields
import BackgroundImage from '../../../assets/Background.png';


const SignUp = () => {
  // Initial form state
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    company: '',
    role: '', 
    isVerified: false,
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await addUser({
        ...formData,
        isVerified: false,  // Add more properties like `isVerified` if needed
      });

      setSuccessMessage('User added successfully!');
      setErrorMessage('');

      setTimeout(() => {
        window.location.href = '/verify-email';  // Redirect after successful signup
      }, 10);

    } catch (error) {
      console.error('Error during sign-up:', error.message);
      setErrorMessage(error.message);
      setSuccessMessage('');
    }
  };

  return (
    <div className={styles.loginPage} style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className={styles.loginImage}></div>
      <div className={styles.loginFormContainer}>
        <div className={styles.loginForm}>
          <h2>Sign Up</h2>

          {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}

          {/* Pass the fields prop to CreateForm */}
          <CreateForm
            formData={formData}  // Pass formData to CreateForm
            setFormData={setFormData}  // Pass setFormData to CreateForm to update state
            onSubmit={handleSubmit}  // Pass handleSubmit to CreateForm to handle form submission
            fields={FormFields.fields}  // Pass FormFields.fields as the fields prop
            text="Sign Up"
          />
        </div>
      </div>
    </div>
  );
};

export default SignUp;
